export const LANGUAGE_VERSIONS = {
  javascript: "18.15.0",
  typescript: "5.0.3",
  python: "3.10.0",
  java: "15.0.2",
  csharp: "6.12.0",
  php: "8.2.3",
  cpp:"10.2.0",
  c:"10.2.0",
  dart:"2.19.6",
  bash:"5.2.0",
  swift:"5.3.3",
  rust:"1.68.2",
  ruby:"3.0.1",
  go:"1.16.2",
};

